import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { Box } from "@mui/material";
import { colors, alphaVar } from "../../../../../ui/colors";
import { JobEventForInvoice, useJobEventsBoard } from "../context";

interface Props {
  jobEvent: JobEventForInvoice;
}

export function JobEventBulkWorkforceCheck({ jobEvent }: Props) {
  const { selectBulkWorkforceEvent, unSelectBulkWorkforceEvent, isBulkWorkforceEventSelected } = useJobEventsBoard();

  const isSelected = isBulkWorkforceEventSelected(jobEvent.uid);

  const handleToggle = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();

    if (isSelected) {
      unSelectBulkWorkforceEvent(jobEvent.uid);
      return;
    }

    selectBulkWorkforceEvent(jobEvent);
  };

  return (
    <Box
      onClick={handleToggle}
      sx={{
        width: 24,
        height: 24,
        borderRadius: "8px",
        border: `1px solid ${isSelected ? colors.blue[500] : colors.gray[200]}`,
        bgcolor: isSelected ? alphaVar(colors.blue[100], 0.8) : "var(--fx-surface-base, #FFFFFF)",
        color: isSelected ? colors.blue[700] : "transparent",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        transition: "all 0.15s ease",
        cursor: "pointer",
        "&:hover": {
          borderColor: colors.blue[400],
          bgcolor: alphaVar(colors.blue[100], 0.55),
        },
      }}
    >
      <CheckRoundedIcon sx={{ fontSize: 16 }} />
    </Box>
  );
}
